import React, { useState, useEffect } from "react"
import { Container } from "./style"
import { useAuth } from "../../hooks/useAuth"
// import { FcGoogle } from "react-icons/fc"
import { useNavigate } from "react-router-dom"

export const LoginModal = () => {
   const { handleLogin, authenticated, loading } = useAuth()
   const [email, setEmail] = useState("")
   const navigate = useNavigate()

   useEffect(() => {
      if (!loading && authenticated) {
         navigate("/", { replace: true })
      }
   }, [authenticated, navigate, loading])

   const handleSubmit = (e) => {
      e.preventDefault()

      if (email.trim() === "") {
         alert("Por favor, insira um email.")
         return
      }

      if (!email.endsWith("@bowe.co")) {
         alert("Você não está autorizado a acessar essa aplicação.")
         return
      }

      handleLogin(email)
   }

   return (
      <Container>
         <div>
            <img src="/images/logo.png" alt="Logo Bowe" />
            <p>Entre com sua conta bowe.co</p>
            <form onSubmit={handleSubmit}>
               <input
                  type="email"
                  // placeholder="Email de uso único"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
               />
               <button type="submit">Entrar</button>
            </form>
         </div>
      </Container>
   )
}
